import { cn } from "@/lib/utils/cn";
import { IconVerified } from "./Icons";

interface VerifiedBadgeProps {
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
  label?: string;
}

const sizeMap = {
  xs: "w-3.5 h-3.5",
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6",
};

export function VerifiedBadge({ size = "sm", className, label }: VerifiedBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center flex-shrink-0",
        sizeMap[size],
        className
      )}
      title={label || "Verified account"}
      aria-label={label || "Verified account"}
    >
      <IconVerified className="w-full h-full" />
    </span>
  );
}
